import type { Cart } from "@commercetools/platform-sdk";
import type { ExpandedOrder } from "../../utils/commercetools/order-service";

export const taxIsIncludedInPrice = (cartOrOrder: Cart | ExpandedOrder) => {
	return cartOrOrder.lineItems[0]?.taxRate?.includedInPrice ?? false;
};
